/**
 * Build readable lines for return/reconciliation timeline entries.
 * @param {{ meta?: object } | null | undefined} transition
 * @returns {string[]}
 */
export function getReconciliationTimelineDetails(transition) {
  const meta = transition?.meta
  if (!meta || typeof meta !== 'object') return []

  const lines = []
  const returnedItems = Array.isArray(meta.returned_items)
    ? meta.returned_items
    : Array.isArray(meta.returned_products)
      ? meta.returned_products
      : []
  const reconciledItems = Array.isArray(meta.reconciled_products)
    ? meta.reconciled_products
    : []

  for (const item of returnedItems) {
    const name = item.product_name || item.product_id || 'Product'
    const qty = item.damaged_quantity ?? item.quantity
    if (qty == null) continue
    const reason =
      typeof item.remarks === 'string'
        ? item.remarks.trim()
        : typeof item.return_reason === 'string'
          ? item.return_reason.trim()
          : ''
    lines.push(
      reason
        ? `${name}: ${qty} returned — ${reason}`
        : `${name}: ${qty} returned`,
    )
  }

  for (const item of reconciledItems) {
    const name = item.product_name || item.product_id || 'Product'
    const qty = item.reconcile_quantity ?? item.quantity
    if (qty != null) {
      lines.push(`${name}: ${qty} reconciled`)
    }
  }

  if (meta.shipment_number != null) {
    lines.push(`Shipment #${meta.shipment_number}`)
  }

  return lines
}
